import { DemoEndpoint } from '../../demo-service';
import { propertyEndpoint } from './customer/property';

const customerEndpoint: DemoEndpoint = {
  path: 'customer',
  endpoints: [propertyEndpoint]
};

export { customerEndpoint };
